import styled from "@emotion/styled";
import {H1, H3, H4} from "../../../../components/typography";
import Page from "../../../../components/Page";
import {ContentBox, Section, TextContent, TitleContent} from "./PersonalInfoCollect";


const Ol = styled.ul`
    list-style: decimal;
    padding-left: 10px;
    color: #A2A2A2;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7;
    margin: 10px 0 0 10px;    
`;

export default function ServiceTerms() {
    return (
        <ContentBox>
            <TitleContent><H1>통합간편인증서비스 이용 동의</H1></TitleContent>
            <TextContent>
                <Section>
                    <H3>제1조 (목적)</H3>
                    <H4>본 서비스 이용약관(이하 “약관”이라 합니다)은 전자서명법, 전자문서법, 개인정보보호법 등(이하 “관련법령”이라 합니다)에 의거하여 한국정보인증 주식회사(이하 "한국정보인증")가 운영하는
                        통합간편인증서비스(이하 “서비스”이라 합니다)의 서비스 이용 조건, 절차 및 한국정보인증과 이용자 간 권리와 의무, 책임사항 등을 규정함을 목적으로 합니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제2조 (용어 정의)</H3>
                    <H4 mt={10}>① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</H4>
                    <Ol>
                        <li>“서비스”라 함은 한국정보인증이 이용자와 이용기관에 제공하는 각 인증기관의 인증서비스를 통합 제공하는 서비스를 말합니다.</li>
                        <li>“이용자”라 함은 본 약관에 동의하고, 인증기관으로부터 인증서를 발급받아 서비스를 이용하는 자를 말합니다.</li>
                        <li>“이용기관”이라 함은 한국정보인증과 계약을 체결하고 서비스를 제공받는 자를 말합니다.</li>
                        <li>“인증기관”이라 함은 전자서명인증사업자 업무를 수행하는 자를 말합니다.</li>
                        <li>“홈페이지”라 함은 한국정보인증이 서비스를 제공하는 웹사이트(https://kiap.signgate.com)를 말합니다.</li>
                    </Ol>
                    <H4 mt={10}>② 본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관련법령 또는 일반적인 상관례에 따릅니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제3조 (약관의 효력 등)</H3>
                    <H4 mt={10}>① 본 약관은 이용자가 본 약관에 동의하고 서비스를 이용함과 동시에 효력이 발생합니다. 한국정보인증은 이 경우, 이용자가 한국정보인증과 통합간편인증서비스 이용계약을 체결한 것으로 간주합니다.</H4>
                    <H4 mt={10}>② 한국정보인증은 본 약관을 서비스 화면이나 홈페이지 등에 게시하거나 별도 동의 절차를 통해 고지하여 이용자가 약관의 내용을 확인할 수 있도록 합니다.</H4>
                    <H4 mt={10}>③ 한국정보인증은 약관의 규제에 관한 법률 및 기타 관련법령에 위배되지 않는 범위에서 본 약관의 내용을 개정할 수 있으며, 개정된 경우에는 시행 7일 이전에 제1항과 같은 방법으로 공지합니다.
                        다만, 이용자의 권리와 의무에 관하여 불리하게 변경되는 내용의 개정은 시행 30일 이전에 공지합니다.</H4>
                    <H4 mt={10}>④ 이용자가 제3항에 따라 개정약관은 이용자에게 통지하였음에도 이용자가 명시적으로 약관 개정에 대한 거부 의사를 표시하지 아니한 경우, 한국정보인증은 이용자가 개정약관에 동의한 것으로
                        간주합니다.</H4>
                    <H4 mt={10}>⑤ 이용자가 개정약관의 내용에 동의하지 않는 경우, 한국정보인증은 해당 이용자에 대하여 개정약관의 내용을 적용할 수 없으며, 이 경우에 한국정보인증은 이용자의 서비스 이용을 제한할 수 있습니다.
                        또한, 한국정보인증이 개정약관에 동의하지 않은 이용자에게 개정 전 약관을 적용할 수 없는 경우, 한국정보인증은 해당 이용자와의 서비스 이용계약을 해지할 수 있습니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제4조 (약관 외 준칙)</H3>
                    <H4 mt={10}>본 약관에 명시되지 않은 사항에 대하여는 관련법령 및 개별 인증기관의 업무준칙, 일반적인 상관례에 따릅니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제5조 (통지) </H3>
                    <H4 mt={10}>① 한국정보인증은 이용자에게 개별 통지하는 경우, 본 약관에서 달리 정하지 않는 한 전화, 문자, 이메일 등 이용자가 동의한 수단으로 통지합니다.</H4>
                    <H4 mt={10}> ② 한국정보인증은 이용자 전체 또는 일부에 대한 통지의 경우, 7일 이상 홈페이지의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제6조 (약관 동의 철회 및 서비스 해지) </H3>
                    <H4 mt={10}>① 이용자는 홈페이지 또는 고객센터를 통하여 본 약관에 대한 동의를 철회할 수 있으며, 한국정보인증은 이를 확인한 후 이용 계약을 해지할 수 있습니다.</H4>
                    <H4 mt={10}> ② 약관 동의 철회 시 서비스 이용이 중단되기에 인증기관을 통한 간편인증 및 전자서명 서비스는 제공되지 않습니다.</H4>
                    <H4 mt={10}> ③ 한국정보인증은 이용자의 약관 철회에 따른 서비스 해지 시, 수집된 개인정보 및 인증 관련 정보를 관련법령 및 회사의 정책에 따라 파기하며, 일정 기간 보관이 요구되는 정보는 해당 기간 동안 안전하게 보관됩니다.</H4>

                </Section>
                <Section>
                    <H3 mt={10}>제7조 (서비스의 내용)</H3>
                    <H4 mt={10}>① 한국정보인증은 각 인증기관이 제공하는 다음 각 호의 서비스를 중계하여 이용기관에 통합 제공합니다.</H4>
                    <Ol>
                        <li>이용기관에서 이용자를 확인하는 간편인증 서비스</li>
                        <li>이용기관에서 이용자에게 요구하는 전자문서에 대한 전자서명 서비스</li>
                    </Ol>
                    <H4 mt={10}> ② 이용자에 대한 간편인증 서비스 절차는 다음 각 호와 같습니다. </H4>

                    <Ol>
                        <li>이용자는 간편인증 서비스에 이용할 인증기관을 선택한 뒤 본 약관을 포함한 한국정보인증의 필수 동의 항목에 대하여 동의합니다.</li>
                        <li>이용자는 간편인증 서비스에 필요한 이용자 정보를 한국정보인증에 제공하고 한국정보인증은 이용자가 선택한 인증기관에 이용자 확인 정보를 요청합니다.</li>
                        <li>인증기관은 이용자 확인 정보를 한국정보인증에 제공하고, 한국정보인증은 해당 정보를 이용기관에 제공합니다.</li>
                        <li>이용기관은 이용자 확인 정보와 이용기관이 보유한 이용자 정보를 비교하여 이용자를 확인합니다.</li>
                    </Ol>
                    <H4 mt={10}> ③ 전자서명 서비스 절차는 다음 각 호와 같습니다. </H4>
                    <Ol>
                        <li>이용자는 전자서명 서비스에 이용할 인증기관을 선택한 뒤 본 약관을 포함한 한국정보인증의 필수 동의 항목에 대하여 동의합니다.</li>
                        <li>이용자는 전자서명 서비스에 필요한 이용자 정보를 한국정보인증에 제공하고 한국정보인증은 이용자가 선택한 인증기관에 전자서명을 요청합니다.</li>
                        <li>인증기관은 전자서명 정보를 한국정보인증에 제공하고, 한국정보인증은 해당 정보를 이용기관에 제공합니다.</li>
                    </Ol>
                </Section>
                <Section>
                    <H3 mt={10}>제8조 (서비스 이용시간) </H3>
                    <H4 mt={10}>한국정보인증은 서비스의 운영상 또는 기술상 특별한 지장이 없는 한 서비스를 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 다만, 정기점검 및 기타 운영상의 사유와 목적, 기술상의 이유에
                        따라 한국정보인증이 정한 기간에 서비스를 일시 중지할 수 있으며, 각 이용기관 및 인증기관의 사유로 인하여 일시 중지될 수 있습니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제9조 (서비스의 이용제한) </H3>
                    <H4 mt={10}>한국정보인증은 다음 각 호의 경우, 이용자의 서비스 이용을 제한할 수 있습니다.
                    </H4>
                    <Ol>
                        <li>한국정보인증이 업무상 또는 기술상의 문제로 서비스를 제공할 수 없는 경우</li>
                        <li>이용기관 또는 인증기관의 업무상 또는 기술상의 문제로 서비스를 제공할 수 없는 경우</li>
                        <li>이용자가 한국정보인증이 요구하는 필수 동의 항목에 동의하지 않은 경우</li>
                        <li>이용자가 입력한 정보가 허위라고 판단되는 경우</li>
                        <li>이용자가 인증기관이 제공하는 절차를 완료하지 못한 경우</li>
                        <li>이용자 또는 이용기관이 서비스를 불법적이거나 부당한 용도로 사용할 우려가 있는 경우</li>
                        <li>이용자가 서비스의 정상적인 운영을 방해하거나 서비스 관련 정보를 취득 및 도용하는 등의 행위를 하는 경우</li>
                        <li>기타 이용자가 이용기관 또는 인증기관이 규정한 제반사항을 위반하는 행위를 하는 경우</li>
                    </Ol>

                </Section>
                <Section>
                    <H3 mt={10}>제10조 (서비스의 변경 및 중단) </H3>
                    <H4 mt={10}>① 한국정보인증은 상당한 이유가 있는 경우, 운영상 및 기술상의 필요에 따라 서비스의 전부 또는 일부를 변경할 수 있습니다. </H4>
                    <H4 mt={10}>② 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등을 그 변경 전 7일 이상 홈페이지에 게시합니다. </H4>
                    <H4 mt={10}>③ 한국정보인증은 제2항의 변경 내용이 중대하거나 이용자에게 불리한 경우에는 이용자에게 제6조(통지)에서 정한 방법으로 통지하고 동의를 받습니다. 이 때, 한국정보인증은 동의를 거절한 이용자에 대하여는 변경 전 서비스를
                        제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우, 한국정보인증은 서비스 이용 계약을 해지할 수 있습니다. </H4>
                    <H4 mt={10}>④ 한국정보인증은 시스템 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우, 서비스의 제공을 일시적으로 중단할 수 있습니다. 또한 이용자에게 제6조 (통지)에서 정한 방법으로 서비스
                        중단을 통지합니다. 다만, 한국정보인증이 사전에 통지할 수 없는 부득이한 사유가 있는 경우에는 사후에 통지할 수 있습니다. </H4>
                </Section>
                <Section>
                    <H3 mt={10}>제11조 (양도 금지)</H3>
                    <H4 mt={10}>이용자는 서비스 이용권한 및 기타 이용 계약상의 지위를 타인에게 양도, 증여하거나 담보로 제공할 수 없습니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제12조 (비밀유지)</H3>
                    <H4 mt={10}>서비스 이용과정에서 취득한 상대방의 비밀정보는 본 약관 목적 외로 사용되거나 제3자에게 누설 또는 공개하여서는 아니 되며, 이는 서비스 이용기간이 종료된 이후에도 유효합니다. 다만, 이미 공개된
                        정보, 관련법령에 의하여 공개 의무가 있는 경우는 제외됩니다.</H4>
                </Section>
                <Section>
                    <H3 mt={10}>제13조 (지식재산권 등의 귀속) </H3>
                    <H4 mt={10}>① 한국정보인증이 작성한 저작물 및 서비스 관련 자료에 대한 저작권 및 기타 지식재산권은 한국정보인증에 귀속되며, 무단 이용은 금지됩니다. </H4>
                    <H4 mt={10}>② 이용기관이 작성한 저작물에 대한 저작권 및 기타 지식재산권은 이용기관에 귀속됩니다. </H4>
                    <H4 mt={10}>③ 이용자는 한국정보인증이 제공하는 서비스를 이용함으로써 얻은 정보 중 한국정보인증 또는 이용기관에 귀속된 지식재산권 정보를 해당 업체의 사전 승낙 없이 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 아니 됩니다. </H4>
                    <H4 mt={10}>④ 한국정보인증은 이용자의 저작물을 사용하는 경우, 해당 이용자의 동의를 받습니다. </H4>
                </Section>

                <Section>
                    <H3 mt={10}>제14조 (손해배상)</H3>
                    <H4 mt={10}>① 한국정보인증은 한국정보인증의 고의 또는 중대한 과실로 인하여 이용자에게 손해를 입힌 경우, 그 손해에 대하여 배상하여야 합니다.</H4>
                    <H4 mt={10}>② 이용자는 서비스 이용과 관련하여 이용자의 귀책사유로 한국정보인증, 이용기관, 인증기관 또는 제3자에게 손해를 입힌 경우, 그 손해에 대하여 배상하여야 합니다.</H4>
                </Section>

                <Section>
                    <H3 mt={10}>제15조 (면책 및 책임제한)</H3>
                    <H4 mt={10}>한국정보인증은 다음 각 호의 경우에 대하여 책임지지 않습니다.</H4>
                    <Ol>
                        <li>천재지변, 전쟁, 테러 등 불가항력적인 사유로 인한 서비스 장애</li>
                        <li>이용자의 귀책사유로 인한 서비스 이용 장애</li>
                        <li>이용자가 제공한 정보의 부정확성 또는 허위로 인한 문제</li>
                    </Ol>
                </Section>
                <Section>
                    <H3 mt={10}>제16조 (준거법 및 재판관할)</H3>
                    <H4 mt={10}>본 약관의 해석 및 적용은 대한민국법에 따르며, 서비스 이용과 관련한 분쟁은 민사소송법상의 관할법원을 제1심 관할법원으로 합니다.</H4>
                </Section>
                <Section style={{paddingBottom: "30px"}}>
                    <H3 style={{marginTop: "30px"}}>부칙</H3>
                    <H4 mt={10}>(시행일) 본 약관은 2025년 7월 11일부터 시행합니다.</H4>
                </Section>
            </TextContent>
        </ContentBox>
    );
}
